(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lab", [], factory);
	else if(typeof exports === 'object')
		exports["lab"] = factory();
	else
		root["lab"] = factory();
})(window, function() {
return 